import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Icons,
  useViewportGrid,
} from '@ohif/ui-next';
import { VIEWER_HEADER_ACTION_BUTTON_CLASSNAME } from '../ImportStudy/constants';
import { useDownloadExportStore } from '../../stores/useDownloadExportStore';
import ViewportDownloadMenu from './ViewportDownloadMenu';

function StudyBrowserDownloadButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [{ activeViewportId }] = useViewportGrid();
  const isExporting = useDownloadExportStore(state => state.isExporting);

  const handleOpenChange = useCallback(
    (openState: boolean) => {
      if (isExporting && !openState) {
        return;
      }

      setIsOpen(openState);
    },
    [isExporting]
  );

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!activeViewportId) {
    return null;
  }

  return (
    <div className="study-browser-download">
      <DropdownMenu
        open={isOpen}
        onOpenChange={handleOpenChange}
      >
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className={classnames(
              VIEWER_HEADER_ACTION_BUTTON_CLASSNAME,
              'study-browser-download__trigger h-9 w-9 min-w-9 px-0',
              isExporting && 'cursor-not-allowed opacity-70'
            )}
            disabled={isExporting}
            aria-label={isExporting ? 'Download in progress' : 'Download'}
            aria-busy={isExporting}
            data-cy="study-browser-download-trigger"
          >
            {isExporting ? (
              <Icons.LoadingSpinner className="h-4 w-4 shrink-0 animate-spin text-white" />
            ) : (
              <Icons.Download className="h-4 w-4 shrink-0 text-white" />
            )}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          side="top"
          align="start"
          sideOffset={8}
          className="study-browser-download__menu viewport-download-menu !border-[#e5e5e5] !bg-white !text-[#334155] min-w-[12rem] w-max max-w-[min(20rem,calc(100vw-2rem))] p-1 shadow-lg"
          data-cy="viewport-download-menu"
          onCloseAutoFocus={event => {
            if (isExporting) {
              event.preventDefault();
            }
          }}
        >
          <ViewportDownloadMenu
            viewportId={activeViewportId}
            variant="studyBrowser"
            onActionComplete={handleClose}
            onExportComplete={handleClose}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

export default StudyBrowserDownloadButton;
